import { Link } from 'react-router-dom';
import { UseAuthContext } from '../../../context/AuthContext';
import { useEffect, useState } from 'react';
import { defaultImage } from "../../../context/defaultImg";
import Admin from './Admin';

export default function Account() {
    const { user, teacher, mess } = UseAuthContext();
    const [userInfo, setUserInfo] = useState(user);
    const [teacherInfo, setTeacherInfo] = useState(teacher);
    const [messInfo, setMessInfo] = useState(mess.details);
    useEffect(() => {
        setUserInfo(user);
        setTeacherInfo(teacher);
        setMessInfo(mess.details);
    }, [user, teacher, mess])

    return (
        <main id="main">
            <section id="portfolio-details" className="portfolio-details text-start">
                <div className="container">
                    <div className="row gy-3">
                        <div className="col-lg-4">
                            <div className="portfolio-details-slider">
                                <div className="text-center">
                                    <img src={userInfo.pic ? userInfo.pic : defaultImage} alt="add" />
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-8">
                            <div className="portfolio-info">
                                <h3>
                                    <div className="row">
                                        <div className="col-12 col-sm-12">
                                            <span>Profile Details </span>
                                            <Link to="/editUser">
                                                <i className='bx bx-edit'></i></Link>
                                        </div>
                                    </div></h3>
                                <div className="row">
                                    <div className="col-12 col-sm-6">
                                        Name: <strong>{userInfo?.name}</strong>
                                    </div>
                                    <div className="col-12 col-sm-6">
                                        Email: {userInfo.email}
                                    </div>
                                    <div className="col-12 col-sm-6">
                                        Gender: {userInfo.gender}
                                    </div>
                                    <div className="col-12 col-sm-6">
                                        Phone: {userInfo.phone}
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        {userInfo.profile.includes("Teacher") && <div className="col-lg-12">
                            <div className="portfolio-info">
                                <h3>
                                    <div className="row">
                                        <div className="col-8 col-sm-8">
                                            <span>Teacher </span>
                                        </div>
                                    </div></h3>
                                <div className="row">
                                    <div className="col-12 col-sm-6">
                                        Degree: {teacherInfo.degree}
                                    </div>
                                    <div className="col-12 col-sm-6">
                                        Experience: {teacherInfo.experience}
                                    </div>
                                    <div className="col-12 col-sm-6">
                                        Courses: {teacherInfo.courses}
                                    </div>
                                    <div className="col-12 col-sm-6">
                                        Subject: {teacherInfo.subject}
                                    </div>
                                    <div className="col-12 col-sm-6">
                                        Language: {teacherInfo.language}
                                    </div>
                                    <div className="col-12 col-sm-6">
                                        Fees: {teacherInfo.fees}
                                    </div>
                                    <div className="col-12 col-sm-6">
                                        Area: {teacherInfo.area}
                                    </div>
                                    <div className="col-12 col-sm-6">
                                        District: {teacherInfo.district}
                                    </div>
                                    <div className="col-12 col-sm-6">
                                        State: {teacherInfo.state}
                                    </div>
                                    <div className="col-12 col-sm-6">
                                        Pin: {teacherInfo.pin}
                                    </div>
                                    <div className="col-12 col-sm-6">
                                        Review: {teacherInfo.review}
                                    </div>
                                    <div className="col-12 col-sm-12 mt-2">
                                        <b>Information:</b>
                                        <hr />
                                        {teacherInfo.information}
                                    </div>
                                </div>
                            </div>
                        </div>}
                        {userInfo.profile.includes("Mess") && <div className="col-lg-12">
                            <div className="portfolio-info">
                                <h3>
                                    <div className="row">
                                        <div className="col-8 col-sm-8">
                                            <span>Mess/Flat </span>
                                        </div>
                                    </div></h3>
                                {messInfo.length > 0 && messInfo.map(m => <div key={m.id} className="row">
                                    <div className="col-12 col-sm-12">
                                    <div className="row">
                                            {m.pic && m.pic.length > 0 && m.pic.map((p, index) => <div key={index} className="col-12 col-sm-4">
                                                <img src={p} alt="mess pic" className="img-fluid" /></div>)}
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-6">
                                        Type: {m.type}
                                    </div>
                                    <div className="col-12 col-sm-6">
                                        For: {m.for}
                                    </div>
                                    <div className="col-12 col-sm-6">
                                        Rent: {m.rent}
                                    </div>
                                    <div className="col-12 col-sm-6">
                                        Area: {m.area}
                                    </div>
                                    <div className="col-12 col-sm-6">
                                        District: {m.district}
                                    </div>
                                    <div className="col-12 col-sm-6">
                                        State: {m.state}
                                    </div>
                                    <div className="col-12 col-sm-6">
                                        Pin: {m.pin}
                                    </div>
                                    <div className="col-12 col-sm-6">
                                        Review: {m.review}
                                    </div>
                                    <div className="col-12 col-sm-12 mt-3">
                                        <b>Information:</b>
                                        <hr />
                                        {m.information}
                                    </div>
                                </div>)}
                            </div>
                        </div>}
                        {userInfo.request.length>0 && <div className="col-lg-12">
                            <div className="portfolio-info">
                                <h3>
                                    <div className="row">
                                        <div className="col-12 col-sm-12">
                                            <span>Application </span>
                                        </div>
                                    </div></h3>
                                <div className="row">
                                    <div className="col-12 col-sm-12 table-responsive">
                                        <table className="table table-striped table-success table-sm">
                                            <thead>
                                                <tr>
                                                <th>Name</th>
                                                <th>Contact</th>
                                                <th>Type</th>
                                                <th>TypeId</th>
                                                <th>Time</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                            {userInfo.request.reverse().map((r,index)=><tr key={index}>
                                                <td>{r.name}</td>
                                                <td>{r.contact}</td>
                                                <td>{r.typeName}</td>
                                                <td>{r.typeId}</td>
                                                <td>{new Date(parseInt(r.reqId)).toLocaleString()}</td>
                                            </tr>)}
                                            </tbody>
                                        </table>
                                    </div>
                                 </div>
                            </div>
                        </div>}
                        {process.env.REACT_APP_ADMIN && 
                        userInfo.admin &&
                        process.env.REACT_APP_ADMIN === userInfo.admin &&
                         <Admin admin={userInfo.admin}/>}
                    </div>
                </div>
            </section>
        </main>
    );
}